import React from "react";
import { GiftIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { CheckList } from "../CheckList";
import { bonuses } from "../../data/content";
export function BonusesSection() {
  return <section className="bg-navy px-4 py-16 md:py-24" data-id="element-116" data-mp="vbu0s4b48l48">
      <div className="mx-auto max-w-6xl" data-id="element-117" data-mp="vclmmnewv4hb">
        <SectionHeading onDark eyebrow="Your complete clinical resource collection" title="The six volumes are just the beginning" data-id="element-118" data-mp="1j1elosqtxsg5" />
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-white/80" data-id="element-119" data-mp="1nzpur19avyxb">
          I also included five practical resources designed to complement the main collection.
        </p>

        <div className="mt-12 space-y-8 md:space-y-12" data-id="element-120" data-mp="1e93klmkcs0m0">
          {bonuses.map((b, i) => <article key={b.label} className="-mx-4 overflow-hidden bg-white md:mx-0 md:grid md:grid-cols-2 md:items-center md:rounded-3xl" data-id="element-121" data-mp="21zh76xk65797" data-mpi={i}>
              <div className={`bg-paper ${i % 2 === 1 ? "md:order-2" : ""}`} data-id="element-122" data-mp="2m6k2vqoyow9p">
                <img src={b.image} alt={`${b.label}: ${b.title}`} className="block w-full" data-id="element-123" data-mp="2h6xo3cthj7ys" />
              </div>
              <div className="px-5 py-7 md:p-10" data-id="element-124" data-mp="2vvk1h8zjxpnd">
                <span className="inline-flex items-center gap-2 rounded-full px-3 py-1 font-display text-sm font-black uppercase text-white" style={{
              backgroundColor: b.color
            }} data-id="element-125" data-mp="2vxepiw64dxvo">
                  <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="2zxf2sdhhg315" />
                  {b.label}
                </span>
                <h3 className="mt-3 font-display text-2xl font-black uppercase leading-tight text-ink md:text-3xl" data-id="element-127" data-mp="3et4sallvmyam">
                  {b.title}
                </h3>
                <p className="mt-3 text-base leading-relaxed text-muted md:text-lg" data-id="element-128" data-mp="1kg58shedljy2">{b.description}</p>
                <p className="mt-5 font-display text-sm font-extrabold uppercase tracking-wide" style={{
              color: b.color
            }} data-id="element-129" data-mp="1fhbredvyx8sm">
                  {b.listTitle}:
                </p>
                <div className="mt-3" data-id="element-130" data-mp="257ad6pkt57dv">
                  <CheckList items={b.items} color={b.color} data-id="element-131" data-mp="29613odurpqs0" />
                </div>
                <p className="mt-5 text-sm italic leading-relaxed text-muted" data-id="element-132" data-mp="2e65k63voeli8">{b.note}</p>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-14 max-w-3xl space-y-4 text-center text-lg leading-relaxed text-white/85" data-id="element-133" data-mp="2j6a3s2rvrwco">
          <h3 className="text-balance font-display text-2xl font-black uppercase leading-tight text-white md:text-3xl" data-id="element-134" data-mp="2o1z62dvabrco">
            A more organized approach to the shoulder cases you encounter
          </h3>
          <p data-id="element-135" data-mp="2wyq1co20j267">
            Whether you’re reviewing a patient with shoulder pain during overhead activities, restricted movement,
            suspected rotator cuff-related symptoms, or an unfamiliar presentation, this collection provides
            educational references designed to help organize your assessment process.
          </p>
          <p data-id="element-136" data-mp="106kmr2e2albb">
            You’ll have a framework for the initial interview, a dedicated screening guide, an examination reference,
            clinical reasoning resources, and educational cases.
          </p>
          <p className="font-semibold text-white" data-id="element-137" data-mp="q964qychpogw">The purpose isn’t to make every patient fit the same pathway.</p>
          <p data-id="element-138" data-mp="lal5p28z5au1">
            It’s to help you approach each assessment with a clearer process while remaining attentive to individual
            presentation, clinical uncertainty, professional scope, and the need for additional evaluation when
            appropriate.
          </p>
        </div>
        <div className="mt-10" data-id="element-139" data-mp="195o5245emwor">
          <CtaButton onDark label="Get all 6 volumes + 5 bonuses" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-140" data-mp="194mj34muops9" />
        </div>
      </div>
    </section>;
}